import axios from 'axios';
import {identity, mergeDeepRight, path} from 'ramda';
import {authActions, authSelectors} from '../features/authSlice';

const pdfGeneratorBaseUrl = process.env.REACT_APP_PDF_GENERATOR_BASE_URL;

const authedPdfGeneratorClient = axios.create({
  baseURL: pdfGeneratorBaseUrl
});

/**
 * we can't just import redux store here because that creates circular dependencies.
 *
 * -> needs to be initialized in index.js after store is created for the first time.
 */
export function initAuthedPdfGeneratorClient(reduxStore) {
  authedPdfGeneratorClient.interceptors.request.use(
    config => {
      const accessToken = authSelectors.accessToken(reduxStore.getState());
      if (!accessToken) {
        return Promise.reject('no access token');
      }
      return mergeDeepRight(config, {headers: {'Authorization': `Bearer ${accessToken}`}});
    }
  );

  const CUSTOM_RETRY_MARKER = '_waRetried';
  const RETRYABLE_STATUS_CODES = new Set([401, 403]);
  authedPdfGeneratorClient.interceptors.response.use(
    identity,
    failedRequest => {
      const retryableStatusCode = RETRYABLE_STATUS_CODES.has(path(['response', 'status'], failedRequest));
      const alreadyRetried = path(['config', CUSTOM_RETRY_MARKER], failedRequest);
      if (!retryableStatusCode || alreadyRetried) {
        return Promise.reject(failedRequest);
      }

      return reduxStore.dispatch(authActions.refresh())
        .then(() => {
          const newConfig = Object.assign({}, failedRequest.response.config, {CUSTOM_RETRY_MARKER: true});
          return authedPdfGeneratorClient.request(newConfig);
        });
    }
  );
}

export {authedPdfGeneratorClient as authedPdfGeneratorClient};